import React, { useEffect } from 'react'
import { CircularProgress, Container } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router'
import { InvoiceList } from './InvoiceList'
import { hasValidatedVendorInvoiceCode } from '../../contexts/useVendorInvoice'
import { useUser } from '../../hooks'
import { VENDOR } from '../../helpers'
import { Routes } from '../../navigation/config/routes'

export const InvoiceListRoot = () => {
    const { workspaceUser } = useUser()
    const history = useHistory()
    const location = useLocation()

    const isVendor = workspaceUser?.active_workspace?.company_type === VENDOR
    const hasValidatedCode = hasValidatedVendorInvoiceCode(
        workspaceUser?.active_workspace?.id,
    )
    const needsCodeVerification = isVendor && !hasValidatedCode

    const isEzfolioRoute = location.pathname.startsWith(
        Routes.organization.invoiceHome,
    )

    useEffect(() => {
        if (needsCodeVerification) {
            const redirectRoute = isEzfolioRoute
                ? Routes.organization.invoiceHome
                : Routes.shared.financial.invoiceHome
            history.replace(redirectRoute)
        }
    }, [needsCodeVerification, history, isEzfolioRoute])

    if (needsCodeVerification) {
        return (
            <Container
                style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: 200,
                }}
            >
                <CircularProgress />
            </Container>
        )
    }

    return <InvoiceList />
}
